import React, { Component } from "react";
import D from "../../../js/debounce.js";

import BirthdayItemField from "./birthday-item-field";
import BirthdayItemInput from "./birthday-item-input";





class BirthdayItem extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.scalePlaceholder  = this.scalePlaceholder.bind(this);

    this.handleFieldClick  = this.handleFieldClick.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputBlur   = this.handleInputBlur.bind(this);

    this.state = {
      open: false,
    };



    // Resize things after a debounce
    window.addEventListener("resize", D(() => {
      this.scalePlaceholder();
    }, 250));
  }



  // ===============================================================================================
  scalePlaceholder() {
    // console.log("INTRO:\n scalePlaceholder()");

    // Implements scale() on a div to make it fit within a container (single line text)
    let wrEle = this.phWrapper;
    let scEle = this.phScaler;

    if (wrEle && scEle) {
      let wrWidth = wrEle.offsetWidth;
      let scWidth = scEle.offsetWidth;

      if (wrWidth && scWidth) {
        // console.log("INTRO:\n ", scWidth, wrWidth);
        if (scWidth <= wrWidth) {
          // If the scaler is less than the container, use no scaling
          scEle.style.transform       = "";
          scEle.style.webkitTransform = "";
        }
        else {
          // If the scaler is greater than the container, use scaling!
          let scale = (wrWidth / scWidth);
          // console.log("INTRO:\n ", scale);
          scEle.style.transform       = `scale(${scale})`;
          scEle.style.webkitTransform = `scale(${scale})`;
        }
      }
    }
  }



  // ===============================================================================================
  handleFieldClick(type) {
    this.setState({ open: type });
    this.props.handleEditing(true);
  }



  // ===============================================================================================
  handleInputChange(type, value) {
    // console.log(`INTRO:\n handleInputChange\nGoing to changed ${type} field, ${value}`);

    this.setState({
      [type]: value,
    });

    let usableValue = value;

    if (type === "name") {
      usableValue = this.getTitleCase(usableValue);
    }
    else if (type === "age") {
      usableValue = this.getValidAge(usableValue);
    }

    this.props.handleChange({
      id:   this.props.id,
      name: ((type === "name") ? usableValue : this.props.name),
      age:  ((type === "age")  ? usableValue : this.props.age),
    });
  }



  // ===============================================================================================
  getTitleCase(str) {
    return str.replace(/\w\S*/g, (txt) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }



  // ===============================================================================================
  getValidAge(str) {
    let curNum = parseInt(str, 10);
    if (typeof curNum === "number" && !isNaN(curNum)) {
      return "" + curNum;
    }
    return "";
  }



  // ===============================================================================================
  handleInputBlur(type) {
    // console.log(`INTRO:\n handleInputBlur\nopen: '${this.state.open}', \nage: '${this.props.age}'`);

    // Finalise the input
    let apparentName = this.props.name;
    let apparentAge  = this.props.age;

    if (type === "name") {
      apparentName = (this.props.name).trim();
    }
    else if (type === "age") {
      apparentAge = parseInt(this.props.age, 10);

      // Parse number
      if (typeof apparentAge === "number" && !isNaN(apparentAge)) {
        apparentAge = "" + Math.max(apparentAge, 1);
      }
      else {
        apparentAge = "";
      }
    }

    // Save finalised input
    this.props.handleChange({
      id:   this.props.id,
      name: apparentName,
      age:  apparentAge,
    });

    // Open the next field, if required
    if (this.state.open === "name" && this.props.name !== "" && this.props.age === "" && this.props.eventType === 'hosted') {
      this.setState({ open: "age"});
      // console.log(`INTRO:\n Blurred ${type} field, ${this.state[type]}, opening age field`);
    }
    else {
      this.setState({ open: false });
      this.props.handleEditing(false);
      // console.log(`INTRO:\n Blurred ${type} field, ${this.state[type]}`);
    }

    this.scalePlaceholder();
  }



  // ===============================================================================================
  render() {
    this.scalePlaceholder();
    let placeholder = {
      "hosted": "Child",
      "no-host": "Name"
    };

    return (
      <div className="birthdays__starchild__item"
        ref={(ele) => { this.phWrapper = ele; }}>



        <div className={"item-placeholders" +
          ((!this.state.open) ? " item-placeholders--shown" : "")}>

          <div className="item-placeholders-scaler"
            ref={(ele) => { this.phScaler = ele; }}>

            <BirthdayItemField type="name"
              value={this.props.name}
              default={placeholder[this.props.eventType]}
              handleClick={this.handleFieldClick}
            />

            &nbsp;&nbsp;

            {this.props.eventType === 'hosted' && (
              <BirthdayItemField type="age"
                value={this.props.age}
                default="6"
                handleClick={this.handleFieldClick}
              />
            )}

          </div>
        </div>



        <div className={"item-inputs" +
          ((this.state.open) ? " item-inputs--shown" : "")}>

          <BirthdayItemInput type="name"
            placeholder="Name"
            isOpen={(this.state.open === "name") ? true : false}
            value={this.props.name}
            handleChange={this.handleInputChange}
            handleBlur={this.handleInputBlur}
          />

          {this.props.eventType === 'hosted' && (
            <BirthdayItemInput type="age"
              placeholder="Age"
              isOpen={this.state.open === "age"}
              value={this.props.age}
              handleChange={this.handleInputChange}
              handleBlur={this.handleInputBlur}
            />
          )}

        </div>



      </div>
    );
  }

}



export default BirthdayItem
